module.exports = __webpack_public_path__ + "img/facebook.fcc0cd8f.svg";